var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gd-pill",class:[`gd-pill-${_vm.status}`, {'gd-pill-sm': _vm.size === 'sm'}]},[_c('fa-icon',{attrs:{"icon":['fal', _vm.icon]}}),_vm._v(_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }